<template>
  <b-modal
    v-model="showModal"
    no-close-on-backdrop
    centered
    size="lg"
    hide-footer
    no-close-on-esc
    hide-header-close
    title="Usuario"
    @hidden="onClose"
  >
    <b-card tag="article" class="mb-2">
      <b-alert show variant="info" class="p-3 text-justify">
        <svg xmlns="http://www.w3.org/2000/svg" width="50" height="50" fill="currentColor"
          class="bi bi-info-circle-fill mr-2" viewBox="0 0 16 16">
          <path
            d="M8 16A8 0 1 0 8 0a8 8 0 0 0 0 16zm.93-9.412-1 4.705c-.07.34.029.533.304.533.194 0 .487-.07.686-.246l-.088.416c-.287.346-.92.598-1.465.598-.703 0-1.002-.422-.808-1.319l.738-3.468c.064-.293.006-.399-.287-.47l-.451-.081.082-.381 2.29-.287zM8 5.5a1 1 0 1 1 0-2 1 1 0 0 1 0 2z" />
        </svg>
        En esta sección, se pueden actualizar ciertos datos del usuario, algunos de estos datos, se actualizan
        automáticamente al momento de que el usuario accede con sus credenciales de google, por ejemplo el avatar.
      </b-alert>
      
      <b-card-text>
        <b-row>
          <div class="col-sm-1"></div>
          <div class="col-sm-10">
            <b-form @submit.prevent>
              <div class="mb-1 my-2">
                <label for="form_user.name"> <small>Nombre</small></label>
                <b-form-input
                  class="my-2"
                  v-model="form.name"
                  type="text"
                  placeholder="Nombre"
                />
              </div>

              <label class="mb-2 mt-2"> <small>Roles disponibles</small></label>
              <v-select
                class="my-3"
                placeholder="Listado completo de roles en la plataforma Aprende"
                v-model="form.roles"
                multiple
                :options="rolesOptionsFiltered"
                :disabled="isGestorEscolar"
              >
                <template v-slot:no-options="{ search, searching }">
                  <template v-if="searching">
                    No resultados para <em>{{ search }}</em>.
                  </template>
                  <em v-else style="opacity: 0.5">Elegir primero.</em>
                </template>
              </v-select>
              <small v-if="isGestorEscolar" class="text-muted">
                <b-icon icon="info-circle" class="mr-1"></b-icon>
                Como Coordinador, no puedes modificar los roles de los usuarios
              </small>

              <div class="mb-2 mt-2">
                <label for="form_user.email"> <small>Correo principal</small></label>
                <b-form-input
                  class="my-2"
                  v-model="form.email"
                  type="text"
                  placeholder="Correo principal"
                  :disabled="correosDeshabilitados"
                />
                <small v-if="correosDeshabilitados" class="text-muted">
                  <b-icon icon="info-circle" class="mr-1"></b-icon>
                  No puedes modificar el correo porque el usuario tiene avance
                </small>
              </div>

              <div class="mb-2 mt-2">
                <label for="form_user.correo_alternativo"> <small>Correo Alternativo</small></label>
                <b-form-input
                  class="my-2"
                  v-model="form.correo_alternativo"
                  type="text"
                  placeholder="Correo alternativo (opcional)"
                  :disabled="correosDeshabilitados"
                />
                <small v-if="correosDeshabilitados" class="text-muted">
                  <b-icon icon="info-circle" class="mr-1"></b-icon>
                  No puedes modificar el correo alternativo porque el usuario tiene avance
                </small>
              </div>

              <div class="mb-2 mt-2">
                <label><small>Escuelas disponibles en Aprende</small></label>
                <v-select
                  class="my-3"
                  placeholder="Listado completo de escuelas en la plataforma Aprende"
                  v-model="form.escuela"
                  :options="escuelasOptionsFiltered"
                  :disabled="isGestorEscolar"
                />
                <small v-if="isGestorEscolar" class="text-muted">
                  <b-icon icon="info-circle" class="mr-1"></b-icon>
                  Como Coordinador, no puedes modificar la escuela de los usuarios
                </small>
              </div>

              <div class="mb-2 mt-2">
                <label><small>Grupos</small></label>
                <v-select
                  class="my-3"
                  placeholder="Listado completo de grupos en la plataforma Aprende"
                  v-model="form.grupos"
                  multiple
                  :options="gruposOptionsFiltered"
                  :disabled="isGestorEscolar"
                />
                <small v-if="isGestorEscolar" class="text-muted">
                  <b-icon icon="info-circle" class="mr-1"></b-icon>
                  Como Coordinador, no puedes modificar los grupos de los usuarios
                </small>
              </div>

              <b-row>
                <b-col>
                  <label for="form_user.fecha_creacion"> <small>Fecha de creación</small></label>
                  <b-form-input
                    class="my-2"
                    v-model="form.fecha_creacion"
                    type="text"
                    disabled
                  />
                </b-col>
                <b-col>
                  <label for="form_user.ultima_fecha_inicio_sesion">
                    <small>Ultimo inicio de sesión a la plataforma</small>
                  </label>
                  <b-form-input
                    class="my-2"
                    v-model="form.ultima_fecha_inicio_sesion"
                    type="text"
                    disabled
                  />
                </b-col>
              </b-row>

              <b-row class="my-2">
                <b-col>
                  <div v-if="form.id > 0">
                    <label for="form_user.ultima_fecha_inicio_sesion"> <small>¿Usuario activo?</small></label>
                    <b-form-checkbox 
                      class="mt-3" 
                      v-model="form.estatus_user" 
                      value="1"
                      :disabled="isGestorEscolar"
                    >
                      Usuario activo
                    </b-form-checkbox>
                    <small v-if="isGestorEscolar" class="text-muted">
                      <b-icon icon="info-circle" class="mr-1"></b-icon>
                      Como Coordinador, no puedes activar/desactivar usuarios
                    </small>
                  </div>
                </b-col>
              </b-row>

              <b-row class="d-flex align-items-start justify-content-start my-1">
                <div class="w-100">
                  <b-button 
                    variant="primary" 
                    size="sm" 
                    class="float-right" 
                    type="button"
                    @click="cancelar"
                  >
                    Cancelar
                  </b-button>
                  <b-button
                    v-if="form.editar === true"
                    variant="info"
                    size="sm"
                    class="float-right mx-2"
                    type="button"
                    @click="actualizar"
                  >
                    Actualizar registro
                  </b-button>
                  <b-button
                    v-if="form.editar === false"
                    variant="success"
                    size="sm"
                    class="float-right mx-2"
                    type="button"
                    @click="guardar"
                  >
                    Guardar
                  </b-button>
                </div>
              </b-row>
            </b-form>
          </div>
          <div class="col-sm-1"></div>
        </b-row>
      </b-card-text>
    </b-card>
  </b-modal>
</template>

<script>
import vSelect from 'vue-select';
import 'vue-select/dist/vue-select.css';
import GestionUsuariosService from '@/services/GestionUsuariosService';
import toast from "@/mixins/ToastMixin.js";

export default {
  name: 'ModalEditarUsuario',
  mixins: [toast],
  components: { vSelect },
  props: {
    value: {
      type: Boolean,
      default: false
    },
    usuario: {
      type: Object,
      default: null
    },
    rolesOptions: {
      type: Array,
      default: () => []
    },
    escuelasOptions: {
      type: Array,
      default: () => []
    },
    gruposOptions: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      form: {
        name: '',
        email: '',
        correo_alternativo: '',
        roles: [],
        grupos: [],
        escuela: null,
        estatus_user: 0,
        id: 0,
        fecha_creacion: '',
        ultima_fecha_inicio_sesion: '',
        editar: false,
        tiene_avance: false
      }
    };
  },
  computed: {
    showModal: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit('input', val);
      }
    },
    isGestorEscolar() {
      const usuario = this.$store.getters.usuario;
      return usuario && usuario.roles && usuario.roles.some(r => r.name === 'gestorEscolarEstudiante');
    },
    correosDeshabilitados() {
      return this.isGestorEscolar && this.form.tiene_avance === true;
    },
    rolesOptionsFiltered() {
      if (!this.isGestorEscolar) {
        return this.rolesOptions;
      }
      
      // Si es gestor escolar creando un nuevo usuario, solo mostrar rol estudiante
      if (!this.form.editar) {
        return this.rolesOptions.filter(r => 
          (r.name && r.name.toLowerCase() === 'estudiante') || 
          (r.label && r.label.toLowerCase() === 'estudiante')
        );
      }
      
      // Si es gestor escolar editando, solo mostrar los roles actuales del usuario
      const currentRoleIds = this.form.roles.map(r => r.id);
      return this.rolesOptions.filter(r => currentRoleIds.includes(r.id));
    },
    escuelasOptionsFiltered() {
      if (!this.isGestorEscolar) {
        return this.escuelasOptions;
      }
      
      // Si es gestor escolar, buscar su escuela por dominio
      const usuario = this.$store.getters.usuario;
      let escuelaCoordinador = null;
      
      if (usuario && usuario.email) {
        const emailParts = usuario.email.split('@');
        if (emailParts.length === 2) {
          const dominio = emailParts[1];
          escuelaCoordinador = this.escuelasOptions.find(e => {
            const dominioEscuela = e.domain || e.dominio || '';
            return dominioEscuela && dominioEscuela.toLowerCase() === dominio.toLowerCase();
          });
        }
      }
      
      // Mostrar solo la escuela del coordinador
      if (escuelaCoordinador) {
        return this.escuelasOptions.filter(e => e.id === escuelaCoordinador.id);
      }
      
      // Si no se encuentra, mostrar la escuela actual del formulario
      if (this.form.escuela && this.form.escuela.id) {
        return this.escuelasOptions.filter(e => e.id === this.form.escuela.id);
      }
      
      return this.escuelasOptions;
    },
    gruposOptionsFiltered() {
      if (!this.isGestorEscolar) {
        return this.gruposOptions;
      }
      // Si es gestor escolar, solo mostrar los grupos actuales del usuario
      const currentGrupoIds = this.form.grupos.map(g => g.id).filter(id => id !== null);
      return this.gruposOptions.filter(g => currentGrupoIds.includes(g.id));
    }
  },
  watch: {
    usuario: {
      handler(newVal) {
        if (newVal) {
          this.cargarDatosUsuario(newVal);
        } else {
          this.resetForm();
        }
      },
      immediate: true,
      deep: true
    },
    value: {
      handler(newVal) {
        if (newVal) {
          // Cuando se abre el modal
          if (this.usuario) {
            // Si hay un usuario, cargar sus datos
            this.$nextTick(() => {
              this.cargarDatosUsuario(this.usuario);
            });
          } else {
            // Si es un nuevo usuario, establecer valores por defecto
            this.$nextTick(() => {
              this.establecerValoresPorDefecto();
            });
          }
        }
      }
    },
    rolesOptions: {
      handler() {
        // Establecer valores por defecto si el modal está abierto y es nuevo usuario
        if (this.value && !this.usuario && this.isGestorEscolar) {
          this.$nextTick(() => {
            this.establecerValoresPorDefecto();
          });
        }
      }
    },
    escuelasOptions: {
      handler() {
        // Establecer valores por defecto si el modal está abierto y es nuevo usuario
        if (this.value && !this.usuario && this.isGestorEscolar) {
          this.$nextTick(() => {
            this.establecerValoresPorDefecto();
          });
        }
      }
    }
  },
  methods: {
    establecerValoresPorDefecto() {
      // Solo aplicar valores por defecto si es gestor escolar y es un nuevo usuario
      if (!this.isGestorEscolar || this.form.editar) {
        return;
      }

      // 1. Establecer rol estudiante por defecto
      if (this.rolesOptions && this.rolesOptions.length > 0) {
        const rolEstudiante = this.rolesOptions.find(r => 
          (r.name && r.name.toLowerCase() === 'estudiante') || 
          (r.label && r.label.toLowerCase() === 'estudiante')
        );
        if (rolEstudiante && this.form.roles.length === 0) {
          this.form.roles = [{ id: rolEstudiante.id, label: rolEstudiante.label || rolEstudiante.name }];
        }
      }

      // 2. Establecer la escuela del dominio del coordinador
      if (this.escuelasOptions && this.escuelasOptions.length > 0 && !this.form.escuela) {
        const usuario = this.$store.getters.usuario;
        
        if (usuario && usuario.email) {
          const emailParts = usuario.email.split('@');
          if (emailParts.length === 2) {
            const dominio = emailParts[1];
            console.log('Dominio del coordinador:', dominio);
            console.log('Escuelas disponibles:', this.escuelasOptions);
            
            // Buscar la escuela que coincida con el dominio del coordinador
            const escuelaCoordinador = this.escuelasOptions.find(e => {
              const dominioEscuela = e.domain || e.dominio || '';
              return dominioEscuela && dominioEscuela.toLowerCase() === dominio.toLowerCase();
            });
            
            console.log('Escuela encontrada:', escuelaCoordinador);
            
            if (escuelaCoordinador) {
              // Usar directamente el objeto de la escuela, no crear uno nuevo
              this.form.escuela = escuelaCoordinador;
              console.log('Escuela asignada al form:', this.form.escuela);
              // Forzar actualización del componente
              this.$forceUpdate();
            } else {
              console.warn('No se encontró ninguna escuela con dominio:', dominio);
            }
          }
        }
      }
    },
    cargarDatosUsuario(user) {
      this.form.editar = true;
      this.form.id = user.id;
      this.form.name = user.name || user.nombre || (user.full_name ? user.full_name : (user['Nombre'] || ''));
      this.form.email = user.email || user.correo || user['Correo'] || '';
      this.form.correo_alternativo = user.correo_alternativo || user['correo_alternativo'] || user['Correo alternativo'] || '';
      this.form.estatus_user = user.estatus_user !== undefined ? user.estatus_user : (user.estatus || 0);
      this.form.ultima_fecha_inicio_sesion = user.ultima_fecha_inicio_sesion || user.ultima_sesion || user['ultima_fecha_inicio_sesion'] || '';
      this.form.fecha_creacion = user.fecha_creacion || user.created_at || user['fecha_creacion'] || '';
      this.form.tiene_avance = user.tiene_avance || false;

      // Escuela
      if (user.escuela && typeof user.escuela === "object" && user.escuela.id) {
        // Buscar el objeto completo de escuela en las opciones
        const foundEscuela = this.escuelasOptions.find(e => e.id === user.escuela.id);
        this.form.escuela = foundEscuela || user.escuela;
      } else if (user.escuela && typeof user.escuela === 'string') {
        const foundEscuela = this.escuelasOptions.find(e => e.label === user.escuela || e.nombre === user.escuela);
        this.form.escuela = foundEscuela || null;
      } else {
        this.form.escuela = null;
      }

      // Grupos
      if (user.grupos && Array.isArray(user.grupos)) {
        this.form.grupos = user.grupos.map(g => {
          if (typeof g === 'object' && g.id) {
            return { id: g.id, label: g.label || g.nombre_grupo };
          } else if (typeof g === 'string') {
            const foundGrupo = this.gruposOptions.find(item => item.label === g || item.nombre_grupo === g);
            return foundGrupo ? { id: foundGrupo.id, label: foundGrupo.label || foundGrupo.nombre_grupo } : { id: null, label: g };
          }
          return g;
        });
      } else if (user.grupos && typeof user.grupos === 'string') {
        this.form.grupos = user.grupos.split(',').map(g => {
          const trimmed = g.trim();
          const foundGrupo = this.gruposOptions.find(item => item.label === trimmed || item.nombre_grupo === trimmed);
          return foundGrupo ? { id: foundGrupo.id, label: foundGrupo.label || foundGrupo.nombre_grupo } : { id: null, label: trimmed };
        });
      } else {
        this.form.grupos = [];
      }

      // Roles
      if (user.roles && Array.isArray(user.roles)) {
        this.form.roles = user.roles.map(r => {
          if (typeof r === 'object' && r.id) {
            return { id: r.id, label: r.label || r.name };
          } else if (typeof r === 'string') {
            const foundRol = this.rolesOptions.find(item => item.label === r || item.name === r);
            return foundRol ? { id: foundRol.id, label: foundRol.label || foundRol.name } : { id: null, label: r };
          }
          return r;
        });
      } else if (user.roles && typeof user.roles === 'string') {
        this.form.roles = user.roles.split(',').map(r => {
          const trimmed = r.trim();
          const foundRol = this.rolesOptions.find(item => item.label === trimmed || item.name === trimmed);
          return foundRol ? { id: foundRol.id, label: foundRol.label || foundRol.name } : { id: null, label: trimmed };
        });
      } else {
        this.form.roles = [];
      }
    },
    resetForm() {
      this.form = {
        name: '',
        email: '',
        correo_alternativo: '',
        roles: [],
        grupos: [],
        escuela: null,
        estatus_user: 0,
        id: 0,
        fecha_creacion: '',
        ultima_fecha_inicio_sesion: '',
        editar: false,
        tiene_avance: false
      };
    },
    validarFormulario() {
      if (!this.form.name || this.form.name.trim() === '') {
        this.toast('b-toaster-bottom-center', true, 'El nombre es obligatorio', 'danger');
        return false;
      }
      if (!this.form.email || this.form.email.trim() === '') {
        this.toast('b-toaster-bottom-center', true, 'El correo es obligatorio', 'danger');
        return false;
      }
      if (!this.form.escuela || !this.form.escuela.id) {
        this.toast('b-toaster-bottom-center', true, 'Selecciona una escuela', 'danger');
        return false;
      }
      return true;
    },
    async guardar() {
      if (!this.validarFormulario()) return;
      
      try {
        let formData = new FormData();
        formData.append("name", this.form.name);
        formData.append("email", this.form.email);
        formData.append("correo_alternativo", this.form.correo_alternativo);
        formData.append("escuela", this.form.escuela.id);
        
        let arrGrupos = [];
        this.form.grupos.forEach(el => { arrGrupos.push(el.id); });
        formData.append("arrGrupos", arrGrupos);
        
        let arrRoles = [];
        this.form.roles.forEach(el => { arrRoles.push(el.id); });
        formData.append("arrRoles", arrRoles);
        
        const response = await GestionUsuariosService.save(formData);
        let { success, message, color } = response.data;
        
        this.toast('b-toaster-bottom-center', true, message, color || (success ? 'success' : 'warning'));
        
        if (success) {
          this.cerrarModal();
          this.$emit('usuario-guardado');
        }
      } catch (error) {
        console.error('Error al guardar usuario:', error);
        
        // Capturar el mensaje del backend si existe
        let errorMessage = 'Ocurrió un error, favor de comunicarse con su administrador 🙏';
        
        if (error.response && error.response.data) {
          // Verificar si hay errores de validación específicos
          if (error.response.data.errors) {
            // Extraer todos los mensajes de error del objeto errors
            const errors = error.response.data.errors;
            const errorMessages = Object.values(errors).flat();
            errorMessage = errorMessages.join(' ');
          } else if (error.response.data.message) {
            errorMessage = error.response.data.message;
          } else if (error.response.data.error) {
            errorMessage = error.response.data.error;
          }
        }
        
        this.toast('b-toaster-bottom-center', true, errorMessage, "danger");
        
        // NO cerrar el modal ni recargar, solo mostrar el error
        return false;
      }
    },
    async actualizar() {
      if (!this.validarFormulario()) return;
      
      try {
        let formData = new FormData();
        formData.append("_method", "PUT");
        formData.append("id", this.form.id);
        formData.append("name", this.form.name);
        formData.append("email", this.form.email);
        formData.append("correo_alternativo", this.form.correo_alternativo);
        formData.append("estatus_user", this.form.estatus_user ? 1 : 0);
        formData.append("escuela", this.form.escuela.id);
        
        let arrGrupos = [];
        this.form.grupos.forEach(el => { arrGrupos.push(el.id); });
        formData.append("arrGrupos", arrGrupos);
        
        let arrRoles = [];
        this.form.roles.forEach(el => { arrRoles.push(el.id); });
        formData.append("arrRoles", arrRoles);
        
        const response = await GestionUsuariosService.update(this.form.id, formData);
        let { success, message, color } = response.data;
        
        this.toast('b-toaster-bottom-center', true, message, color || (success ? 'success' : 'warning'));
        
        if (success) {
          this.cerrarModal();
          this.$emit('usuario-actualizado');
        }
      } catch (error) {
        console.error('Error al actualizar usuario:', error);
        
        // Capturar el mensaje del backend si existe
        let errorMessage = 'Ocurrió un error, favor de comunicarse con su administrador 🙏';
        
        if (error.response && error.response.data) {
          // Verificar si hay errores de validación específicos
          if (error.response.data.errors) {
            // Extraer todos los mensajes de error del objeto errors
            const errors = error.response.data.errors;
            const errorMessages = Object.values(errors).flat();
            errorMessage = errorMessages.join(' ');
          } else if (error.response.data.message) {
            errorMessage = error.response.data.message;
          } else if (error.response.data.error) {
            errorMessage = error.response.data.error;
          }
        }
        
        this.toast('b-toaster-bottom-center', true, errorMessage, "danger");
        
        // NO cerrar el modal ni recargar, solo mostrar el error
        return false;
      }
    },
    cancelar() {
      this.cerrarModal();
    },
    cerrarModal() {
      this.showModal = false;
    },
    onClose() {
      this.resetForm();
      this.$emit('cerrado');
    }
  }
};
</script>
